import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'bs-acca-boost-update-info',
    templateUrl: './acca-boost-update-info.component.html',
    styleUrls: ['./acca-boost-update-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccaBoostUpdateInfoComponent {
    @Output() close = new EventEmitter<void>();

    @HostBinding('class') className = 'acca-boost-module acca-boost-update-info';

    constructor(public sitecore: Sitecore) {}

    onClose(): void {
        this.close.next();
    }
}
